var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg072Silence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.281,286.484c-9.677-17.88-15.281-32.2-15.281-52.482l0.001-30.001c0-41.161-15.943-80.037-44.894-109.466 C341.297,69.313,309.44,53.575,275,49.231v-29.23c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v29.271 c-17.783,2.28-34.895,7.619-51.062,15.95c-9.819,5.06-13.677,17.121-8.617,26.94c3.551,6.889,10.546,10.843,17.796,10.843 c3.084,0,6.215-0.716,9.145-2.226c15.935-8.211,33.107-12.506,51.045-12.765h3.537h0.241 c62.825,0.912,113.916,52.917,113.916,115.987l-0.001,30c0,31.725,10.378,53.554,20.104,71.524 c3.62,6.688,10.501,10.483,17.606,10.483c3.215,0,6.477-0.777,9.503-2.415C427.927,308.335,431.539,296.197,426.281,286.484z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.143,477.859l-472-472c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.474,0,28.284l106.609,106.609 C103.531,160.749,99,182.022,99,204.001v30c0,26.647-9.673,43.566-21.918,64.986c-12.065,21.104-25.739,45.022-32.655,81.924 c-3.301,17.616,1.369,35.627,12.813,49.415c11.433,13.775,28.258,21.675,46.158,21.675h91.99c0,33.084,26.916,60,60,60 s60-26.916,60-60h91.603c5.067,0,10.044-0.621,14.873-1.853l55.995,55.995c3.904,3.906,9.023,5.858,14.141,5.858 c5.118,0,10.237-1.953,14.143-5.858C513.954,498.333,513.954,485.67,506.143,477.859z M255.388,472.001c-11.028,0-20-8.972-20-20 h40C275.388,463.029,266.417,472.001,255.388,472.001z M103.398,412.001c-8.165,0-13.14-4.525-15.379-7.222 c-2.244-2.705-5.785-8.445-4.275-16.5c5.673-30.272,17.056-50.183,28.064-69.439C125.176,295.456,139,271.275,139,234.001v-30 c0-11.004,1.529-21.766,4.558-32.157l240.158,240.157H103.398z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg072Silence);
export default __webpack_public_path__ + "static/media/072-silence.b8f610dea563a6bc09a9f2f189dffa86.svg";
export { ForwardRef as ReactComponent };